import { useEffect, useState } from 'react';
import Toggler from './Toggler';
import MenuItem from './MenuItem';
import styles from './menu.module.scss';

const MENU_ITEMS = [
  {
    label: '2024 大師開講 健康講座',
    href: 'https://cloud.ievent.tw/bi/physical-patient-education-symposium/2024/',
    active: false,
  },
  {
    label: '2025 大師開講 健康講座',
    href: 'https://cloud.ievent.tw/bi/physical-patient-education-symposium',
    active: true,
  },
  {
    label: '2026 大師開講 健康講座',
    href: 'https://cloud.ievent.tw/bi/physical-patient-education-symposium/2026/',
    active: false,
  },
];

export const Menu = () => {
	const [isOpen, setIsOpen] = useState(false);
	const handleToggle = () => setIsOpen((prev) => !prev);
	const handleClose = () => {
		isOpen && setIsOpen(false);
	};

	// todo menu 改為 store 全域狀態管理
	useEffect(() => {
		document.addEventListener('click', handleClose);

		return () => document.removeEventListener('click', handleClose);
	}, [isOpen]);

	return (
		<div className={styles.menuWrapper}>
			<Toggler isOpen={isOpen} onToggle={handleToggle} />
			{isOpen && (
				<div className={styles.menuBox}>
					{MENU_ITEMS.map((item) => (
						<MenuItem
							key={item.href}
							label={item.label}
							href={item.href}
							onClick={handleClose}
							active={item.active}
						/>
					))}
				</div>
			)}
		</div>
	);
};
